// extracted by mini-css-extract-plugin
export default {"card":"donorCheckIn_card__CDICx","checkin-input-lg":"donorCheckIn_checkin-input-lg__sC7jy","customSelect":"donorCheckIn_customSelect__eFeUX"};